













export default {
  name: 'spinning-cube'

  data: -> ready: true
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/geotap/SpinningCube.vue